import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'tl;dv Case Study | Canny';
const Description =
  'Read about how tl;dv uses Canny to transform customer feedback into product innovation.';
const Image = 'https://canny-assets.io/images/77f6b95cbe0e7fd9ac5d2f34d2a732e7.png';
const TldvUrl = 'https://canny.io/case-studies/tldv';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${TldvUrl}#webpage`,
    url: TldvUrl,
    name: 'Case Study: tl;dv × Canny',
    description: 'How tl;dv uses Canny to transform customer feedback into product innovation.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${TldvUrl}#article`,
    genre: 'Case Study',
    headline: 'How tl;dv uses Canny to transform customer feedback into product innovation',
    description:
      'tl;dv installed Canny on day one to manage user feedback effectively. By integrating the Canny widget across the app and sending updates to Slack, their product team stays aligned on feature requests and ensures they act on customer input—making feedback a core part of their development flow.',
    inLanguage: 'en',
    url: TldvUrl,
    mainEntityOfPage: { '@id': `${TldvUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'tl;dv', url: 'https://tldv.io' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'tl;dv', item: TldvUrl },
  ]),
]);

export default class TLDVLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: TldvUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
